import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import {
  FDBox, FDPrimaryActionButton, FDStack, FDTextButton,
} from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import WizardStepDeleteButton from 'Views/Page/Content/Modal/Layouts/DefaultFDWizardStep/Layout/WizardStepDeleteButton';
import { dataAttrs } from 'Helpers/Testing';
import { DialogActions, DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import { RealAssetFields } from 'Views/Page/Content/Modal/Layouts/RealAsset/Layout/minimalFields';
import PropTypes from 'prop-types';

const Layout = ({ isPartOfTypeStep }) => {
  const {
    onSubmit, resource, saving, consumeAttr,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  const onCancel = () => {
    clearModalCollection();
  };

  const onDelete = async () => {
    try {
      await resource.delete();
    } catch (err) {
      displayErrorMessage(err, err.message);
    }
  };

  const onDeleteSuccess = () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  const isEdit = resource.id() > 0;
  const defaultTitle = isEdit ? 'Edit asset' : 'Add an asset';

  return (
    <>
      {!isPartOfTypeStep ? <DialogTitle value={consumeAttr('title') ?? defaultTitle} /> : null}
      <DialogContent>
        <FDStack
          spacing={2}
          direction={'column'}
          alignItems={'stretch'}
        >
          <RealAssetFields />

          <FDBox alignSelf={'center'}>
            {resource.meta().action('DELETE') ? <WizardStepDeleteButton
              onDelete={onDelete}
              onDeleteSuccess={onDeleteSuccess}
              dialogProps={{
                title: 'Are you sure?',
                message: 'Removing this property will delete all of its information. This cannot be undone.',
                cancelLabel: 'Cancel',
                confirmLabel: 'Confirm',
              }}
            /> : null}
          </FDBox>
        </FDStack>
      </DialogContent>
      {!isPartOfTypeStep ? (
        <DialogActions>
          <FDTextButton
            onClick={onCancel}
            disabled={saving}
            label="Cancel"
          />
          <FDPrimaryActionButton
            onClick={onSubmit}
            label="Submit"
            loading={saving}
            {...dataAttrs('real-asset-submit-btn')}
          />
        </DialogActions>
      ) : null}
    </>
  );
};

Layout.defaultProps = {
  isPartOfTypeStep: false,
};

Layout.propTypes = {
  isPartOfTypeStep: PropTypes.bool,
};

export default Layout;
